<template>
  <div class="right-fixed-nav HBKX">
    <el-popover
      placement="left"
      trigger="hover"
      :disabled="linkType === '0'"
      v-for="(
        { title, address, linkType }, index
      ) of fixedNavData"
      :key="index"
    >
      <img
        v-if="linkType === '1'"
        class="qr-code"
        :src="address"
      />
      <section
        class="item"
        @click="openNewPage(address, linkType)"
        slot="reference"
      >
        <img :src="title" />
      </section>
    </el-popover>
  </div>
</template>

<script>
import common from '@/api/module/common'
export default {
  name: 'RightFixedNav', //右侧固定导航组件
  props: {
    side: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      fixedNavData: []
    }
  },
  methods: {
    openNewPage(address, linkType) {
      // linkType 0 外链地址 1 二维码地址
      if (linkType === '0')
        this.$routerLink({ path: address })
    },
    //浮窗
    async getSide() {
      try {
        const { data } = await common.commonSide(this.side)
        if (data.length) this.fixedNavData = data
      } catch (error) {
        console.error(error || '请求失败')
      }
    },
    init() {
      this.getSide()
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="less" scoped>
.right-fixed-nav {
  position: fixed;
  z-index: 100;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  .item {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 8px;
    font-size: 22px;
    overflow: hidden;
    cursor: pointer;
    margin-bottom: 8px;
    transition: all 0.3s;
    color: @font-color-695557;
    border: 1px solid @main-color-BFB2AA;
    background-color: @main-color-F9F9F5;
  }
}
.qr-code {
  width: 120px;
  margin: 0 auto;
  display: block;
}
</style>
